var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('carousel',{attrs:{"data":_vm.data,"controls":false,"indicator-type":"disc","slideOnSwipe":true}})}
var staticRenderFns = []

export { render, staticRenderFns }